module.exports = __webpack_public_path__ + "/images/qr-mobile-download.fa7ff02.png";